import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import UploadFinalXmContents from './upload-final-xm-contents';
import usePrevious from '@nkr/services/use-previous';
import { IValidation } from './final-xm-validation';

interface IProps {
    show: boolean,
    swap: string,
    onSend: (acceptable: number, rootCause: string, correctiveAction: string, initials: string, finalXmFile: File) => void,
    onCancel: () => void
}

const UploadFinalXm = (props: IProps) => {
    const [acceptable, setAcceptable] = useState(-1);
    const [rootCause, setRootCause] = useState('');
    const [correctiveAction, setCorrectiveAction] = useState('');
    const [upload, setUpload] = useState<File>(null);
    const [initials, setInitials] = useState('');
    const [validation, setValidation] = useState<IValidation>({
        acceptable: true,
        rootCause: true,
        correctiveAction: true,
        upload: true,
        initials: true
    });
    const [dirty, setDirty] = useState(false);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            setAcceptable(-1);
            setRootCause('');
            setCorrectiveAction('');
            setUpload(null);
            setInitials('');
            setValidation({
                acceptable: true,
                rootCause: true,
                correctiveAction: true,
                upload: true,
                initials: true
            });
        }
    }, [props.show]);

    const handleSend = () => {
        let newValidation: IValidation = {
            acceptable: acceptable != -1,
            rootCause: acceptable == 0 ? rootCause != '' : true,
            correctiveAction: acceptable == 0 ? correctiveAction != '' : true,
            upload: upload != null,
            initials: initials != ''
        };

        setValidation(newValidation);
        setDirty(true);

        let isValid = newValidation.acceptable && newValidation.rootCause && newValidation.correctiveAction && newValidation.upload && newValidation.initials;

        if (isValid) {
            props.onSend(acceptable, rootCause, correctiveAction, initials, upload);
        }
    };

    const handleCancel = () => {
        props.onCancel();
    };

    const handleAcceptableChange = (acceptable: number) => {
        setAcceptable(acceptable);
    };

    const handleFieldChange = (field: string, value: string) => {
        if (field == 'rootCause') {
            setRootCause(value);
        }

        if (field == 'correctiveAction') {
            setCorrectiveAction(value);
        }

        if (field == 'initials') {
            setInitials(value.slice(0, 4));
        }
    };

    const handleSelectFile = (file: File) => {
        setUpload(file);
    };

    // const disableSubmitButton = acceptable == -1 || initials == '' || upload == null;

    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Record Final XM Results for Swap {props.swap}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <UploadFinalXmContents
                    acceptable={acceptable}
                    rootCause={rootCause}
                    correctiveAction={correctiveAction}
                    initials={initials}
                    upload={upload}
                    validation={validation}
                    dirty={dirty}
                    isList={false}
                    onAcceptedChange={handleAcceptableChange}
                    onFieldChange={handleFieldChange}
                    onUploadChange={handleSelectFile} />
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSend}>Upload Final XM</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadFinalXm;